// Gemeinsame Termin-Helfer für TermineSection (Lead-Detail) und TermineModal (Agenda)

// "2026-07-01T14:30" → lokale Date; behandelt Werte mit/ohne Zeitzone robust
export function parseTermin(ts) {
  if (!ts) return null;
  const d = new Date(ts);
  return isNaN(d.getTime()) ? null : d;
}

// Tages-Überschrift: Heute / Morgen / Wochentag, Datum
export function terminDayLabel(d) {
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const day = new Date(d); day.setHours(0, 0, 0, 0);
  const diff = Math.round((day - today) / 86400000);
  const datum = day.toLocaleDateString('de-DE', { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' });
  if (diff === 0) return `Heute · ${datum}`;
  if (diff === 1) return `Morgen · ${datum}`;
  return datum;
}

export const terminTime = d => d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
export const terminDayKey = d => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x.getTime(); };

// Nach Anlegen/Erledigen/Löschen eines Termins feuern — App aktualisiert dann
// den roten Zähler-Badge in der Navbar (gleicher Event-Mechanismus wie Auth in api.js)
export const TERMINE_CHANGED_EVENT = 'crm:termine-changed';
export const notifyTermineChanged = () => window.dispatchEvent(new Event(TERMINE_CHANGED_EVENT));

// Anzahl der heutigen, noch nicht erledigten Termine
export function countTermineHeute(termine) {
  const todayKey = terminDayKey(new Date());
  return termine.filter(t => {
    if (t.erledigt) return false;
    const d = parseTermin(t.termin_at);
    return d && terminDayKey(d) === todayKey;
  }).length;
}
